import { buildSeo } from "@/data/seoData";

// React 19 hoists <title>, <meta> and <link> rendered here into <head>
const Seo = (props) => {
  const seo = buildSeo(props);
  return (
    <>
      <title>{seo.title}</title>
      {seo.meta.map((m) => (
        <meta key={m.key} {...{ [m.attr]: m.key }} content={m.content} />
      ))}
      {seo.canonical && <link rel="canonical" href={seo.canonical} />}
      {seo.jsonLd.map((data, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
      ))}
    </>
  );
};

export default Seo;
